import { render, staticRenderFns } from "./PurchaseOfferingDone.vue?vue&type=template&id=2e77ae3b&scoped=true"
import script from "./PurchaseOfferingDone.vue?vue&type=script&lang=js"
export * from "./PurchaseOfferingDone.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOfferingDone.vue?vue&type=style&index=0&id=2e77ae3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e77ae3b",
  null
  
)

export default component.exports